import { createSlice } from '@reduxjs/toolkit';
import ctaState from '../../../constants/ctas/initialStates/ctaState';
import emailCollectionState from '../../../constants/ctas/initialStates/emailCollectionState';
import linkState from '../../../constants/ctas/initialStates/linkState';
import dynamicFormState from '../../../constants/ctas/initialStates/dynamicFormState';

// Create a Redux slice for the 'CTA' portion of the state
export const ctaSlice = createSlice({
  name: 'cta', // The name of the slice
  initialState: ctaState, // Initial state for CTA
  reducers: {
    // Action to set CTA data
    setCtasData: (state, action) => {
      state.data = action.payload;
    },
    // Action to set CTA Etc data
    setCtasEtc: (state, action) => {
      state.etc = action.payload;
    },
    // Action to set CTA step
    setCtaStep: (state, action) => {
      state.etc.ctaStep = action.payload;
    },
    // Action to set the next CTA step
    setNextCtaStep: state => {
      state.etc.ctaStep = state.etc.ctaStep + 1;
    },
    // Action to set the previous CTA step
    setPrevCtaStep: state => {
      state.etc.ctaStep = state.etc.ctaStep - 1;
    },
    // Action to set CTA type
    setCtaType: (state, action) => {
      state.etc.ctaType = action.payload;
    },
    // Action to set localBgData
    setCtaLocalBgData: (state, action) => {
      state.etc.localBgData = action.payload;
    },
    // Action to set whether CTA is submittable
    setIsCtaSubmittable: (state, action) => {
      state.etc.isCtaSubmittable = action.payload;
    },
    // Action to set the email collection
    setEmailCollectionCta: (state, action) => {
      state.data[emailCollectionState.actionData.actionType] = action.payload;
    },
    // Action to set the link
    setLinkCta: (state, action) => {
      state.data[linkState.actionData.actionType] = action.payload;
    },
    // Action to set the dynamic form
    setDynamicFormCta: (state, action) => {
      state.data[dynamicFormState.actionData.actionType] = action.payload;
    },
    // Action to set the number of dynamic fields
    setNoOfDynamicFields: (state, action) => {
      state.etc.dynamicFields = action.payload;
    },
    // Action to set the GDPR config (nested under actionData)
    setGdprConfig: (state, action) => {
      const cta = state.data[dynamicFormState.actionData.actionType];
      cta.actionData.gdprConfig = action.payload;
    },
  },
});

// Export the action creators
export const {
  setCtasData,
  setCtasEtc,
  setCtaStep,
  setNextCtaStep,
  setPrevCtaStep,
  setCtaType,
  setCtaLocalBgData,
  setIsCtaSubmittable,
  setEmailCollectionCta,
  setLinkCta,
  setDynamicFormCta,
  setNoOfDynamicFields,
  setGdprConfig,
} = ctaSlice.actions;

// Export the reducer
export default ctaSlice.reducer;
